import React, { Suspense, useState } from 'react';

import { css } from '@emotion/react';
import { Outlet, useLocation, useParams } from 'react-router';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import LoadingSpinner from '@components/Common/LoadingSpinner';
import Navigation from '@components/Common/Navigation';
import SessionExpiredModal from '@components/Modals/SessionExpiredModal';

import { useSessionTimer } from '@hooks/useSessionTimer';

import {
  SCREEN_MAX_WIDTH,
  SCREEN_MIN_WIDTH,
  NAVIGATION_WIDTH,
} from '@constants/layout';

/** 메인 컴포넌트: 레이아웃 */
const Layout = () => {
  const { pathname } = useLocation();
  const { groupId, portfolioId } = useParams();

  /** 세션만료 알림 모달 상태리 */
  const [sessionModalOpen, setSessionModalOpen] = useState<boolean>(false);

  useSessionTimer({
    onIdle: () => setSessionModalOpen(true),
  });

  const isPaddingExcetion =
    /** 계정 정보 관리 */
    // pathname.includes('/users') ||
    /** 사용자 설정 */
    pathname.includes('/mypage') ||
    /** 조합관리 -> 상세정보 -> 포트폴리오 상세정보 */
    (pathname.includes('/fund') && pathname.includes('/portfolio')) ||
    /** 그룹관리  */
    pathname.includes(`/group/detail/${groupId}`) ||
    /** 기업(포트폴리오) 상세 */
    (pathname.includes(`/portfolio/${portfolioId}`) &&
      !pathname.includes(`/portfolio/${portfolioId}/edit`));

  return (
    <>
      <div css={container(SCREEN_MIN_WIDTH)}>
        <main css={mains}>
          <ApiErrorBoundary>
            <Suspense fallback={<LoadingSpinner />}>
              <Navigation />
            </Suspense>
          </ApiErrorBoundary>
          <div
            css={{
              height: '100vh',
              width: '100%',
              overflowY: 'auto',
            }}
          >
            <div
              css={mainStyle(
                SCREEN_MIN_WIDTH,
                SCREEN_MAX_WIDTH,
                NAVIGATION_WIDTH,
                isPaddingExcetion
              )}
            >
              <Outlet />
            </div>
          </div>
        </main>
      </div>
      {sessionModalOpen && <SessionExpiredModal open={sessionModalOpen} />}
    </>
  );
};

export default Layout;

const container = (min: string) => css`
  min-width: ${min ?? '1200px'};
  height: 100vh;
  margin: 0 auto;
`;

const mains = css`
  display: flex;
`;

const mainStyle = (
  min: string,
  max: string,
  nav: string,
  isPaddingException: boolean
) => css`
  height: auto;
  min-width: calc(${min} - ${nav});
  max-width: calc(${max} - ${nav});
  width: 100%;
  ${
    !isPaddingException &&
    css`
      padding: 30px 40px;
      // overflow-y: auto;
    `
  }}
`;
